/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Create_Team_PromptInputs */

const en_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please create a new team to begin.`)
};

const fr_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez créer une nouvelle équipe pour commencer.`)
};

const de_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte erstellen Sie zunächst ein neues Team.`)
};

const it_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare, crea un nuovo team.`)
};

const ru_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, создайте новую команду, чтобы начать.`)
};

const es_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor crea un nuevo equipo para comenzar.`)
};

const zh_cn2_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请创建一个新团队开始。`)
};

const ja_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには新しいチームを作成してください。`)
};

const hi_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया शुरुआत करने के लिए एक नई टीम बनाएं।`)
};

const pt_pt2_team_share_create_team_prompt = /** @type {(inputs: Team_Share_Create_Team_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, crie uma nova equipe para começar.`)
};

/**
* | output |
* | --- |
* | "Please create a new team to begin." |
*
* @param {Team_Share_Create_Team_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_create_team_prompt = /** @type {((inputs?: Team_Share_Create_Team_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Create_Team_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_create_team_prompt(inputs)
	if (locale === "de") return de_team_share_create_team_prompt(inputs)
	if (locale === "it") return it_team_share_create_team_prompt(inputs)
	if (locale === "ru") return ru_team_share_create_team_prompt(inputs)
	if (locale === "es") return es_team_share_create_team_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_create_team_prompt(inputs)
	if (locale === "ja") return ja_team_share_create_team_prompt(inputs)
	if (locale === "hi") return hi_team_share_create_team_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_create_team_prompt(inputs)
	return en_team_share_create_team_prompt(inputs)
});